<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("MESSAGES.Add new festival") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('MESSAGES.Festival image')"
            @selectImage="selectImage"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Festival name arabic')"
            v-model.trim="data.nameAr"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Festival name english')"
            v-model.trim="data.nameEn"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.descProd"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.descProdEn"
            required
          />
          <base-select-input
            col="6"
            :optionsList="allMainProviders"
            required
            :placeholder="$t('MESSAGES.festival provider name')"
            v-model="data.festival_provider_id"
          />
          <base-input
            col="6"
            type="number"
            step="any"
            :placeholder="$t('MESSAGES.adultTicketPrice')"
            v-model.trim="data.price"
            required
          />
          <div class="input_wrapper switch_wrapper my-3 col-6">
            <v-switch
              color="green"
              :label="$t('MESSAGES.is_name_required')"
              v-model="data.is_name_required"
              hide-details
            ></v-switch>
          </div>
          <div class="input_wrapper switch_wrapper my-3 col-6">
            <v-switch
              color="green"
              :label="$t('MESSAGES.children_pricing_enabled')"
              v-model="data.children_pricing_enabled"
              hide-details
            ></v-switch>
          </div>
          <base-input
            v-if="data.children_pricing_enabled"
            col="4"
            type="number"
            min="0"
            max="100"
            :placeholder="$t('MESSAGES.min_age')"
            v-model.trim="data.min_age"
            required
          />
          <base-input
            v-if="data.children_pricing_enabled"
            col="4"
            type="number"
            min="0"
            max="100"
            :placeholder="$t('MESSAGES.max_age')"
            v-model.trim="data.max_age"
            required
          />
          <base-input
            v-if="data.children_pricing_enabled"
            col="4"
            type="number"
            step="any"
            min="0"
            :placeholder="$t('MESSAGES.child_price')"
            v-model.trim="data.child_price"
            required
          />
          <base-select-input
            col="6"
            :optionsList="festivalTypes"
            required
            :placeholder="$t('MESSAGES.Festival type')"
            v-model="data.type"
          />
          <base-select-input
            col="6"
            :optionsList="ticketTypes"
            required
            :placeholder="$t('MESSAGES.ticketType')"
            v-model="data.ticket_type"
          />
          <base-input
            v-if="data.type?.id === 'limited' || data.type?.id === 'extended'"
            col="6"
            type="date"
            :placeholder="$t('MESSAGES.Start date')"
            v-model.trim="data.start_date"
            required
          />
          <base-input
            v-if="data.type?.id === 'extended'"
            col="6"
            type="date"
            :placeholder="$t('MESSAGES.End date')"
            v-model.trim="data.end_date"
            required
          />

          <festival-daily-schedule
            ref="dailySchedule"
            v-model="dailySchedules"
            :start-date="data.start_date"
            :end-date="data.end_date"
            :festival-type="data.type"
          />

          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('MESSAGES.terms of use arabic')"
            v-model.trim="data.usage_policy_ar"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('MESSAGES.terms of use english')"
            v-model.trim="data.usage_policy_en"
            required
          />
          <base-input
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.address')"
            v-model.trim="data.address"
          />
          <div class="col-12 mb-3 input_wrapper top_label select_wrapper">
            <GmapAutocomplete
              @place_changed="setPlace"
              @keyup.enter.stop="setPlace"
              :placeholder="$t('MESSAGES.search_place')"
            />
          </div>
          <div class="col-12">
            <gmap-map
              :center="{
                lat: data.lat ?? 24.7136,
                lng: data.lng ?? 46.6753,
              }"
              :zoom="6"
              style="width: 100%; height: 300px"
              @click="setLocation($event, index)"
            >
              <gmap-marker
                v-if="data.lat && data.lng"
                :position="{
                  lat: data.lat,
                  lng: data.lng,
                }"
              />
            </gmap-map>
            <v-btn @click="resetButton" color="primary" class="mt-2">{{
              $t("PLACEHOLDERS.reset_btn")
            }}</v-btn>
          </div>

          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseMultiImageUploadInput from "../../../components/formInputs/BaseMultiImageUploadInput.vue";
import BaseNamePreviewFileUploadInput from "../../../components/formInputs/BaseNamePreviewFileUploadInput.vue";
import ChangableMapComponent from "@/components/general/ChangableMapComponent";
import FestivalDailySchedule from "@/components/festivals/FestivalDailySchedule.vue";
import {
  appendScheduleToFormData,
  formatDateForApi,
  getFestivalApiErrorMessage,
  validateFestivalSchedulePrerequisites,
  validateSchedules,
  validateUsagePolicyFields,
} from "@/utils/festivalSchedule";

export default {
  name: "CreateProviders",

  components: {
    ChangableMapComponent,
    BaseMultiImageUploadInput,
    BaseNamePreviewFileUploadInput,
    FestivalDailySchedule,
  },

  data() {
    return {
      isWaitingRequest: false,
      sections: [],
      section_id: null,
      store_waiting: null,
      file: null,
      fileType: "",
      phone_numbers: [
        {
          phone: "",
        },
      ],
      allMainProviders: [],
      additionalImages: [],
      dailySchedules: [],
      data: {
        media: {
          path: null,
          file: null,
        },
        additionalImages: [],
        whatsapp_number: null,
        price: 0,
        is_name_required: false,
        children_pricing_enabled: false,
        min_age: null,
        max_age: null,
        child_price: null,
        festival_provider_id: null,
        ticket_type: null,
        type: null,
        start_date: null,
        end_date: null,
        usage_policy_ar: "",
        usage_policy_en: "",
        nameAr: null,
        social_media_links: {
          facebook: null,
          instagram: null,
          tiktok: null,
          x: null,
          snapchat: null,
        },
        nameEn: null,
        descProd: null,
        lat: null,
        lng: null,
        address: null,
        descProdEn: null,
        dropdownOptions: {},
        active: true,
        featured_tag: true,
        email: null,
        password: null,
        passwordConfirmation: null,
      },
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },
  computed: {
    festivalTypes() {
      return [
        { id: "extended", name: this.$t("MESSAGES.Extended") },
        { id: "limited", name: this.$t("MESSAGES.Limited") },
      ];
    },
    ticketTypes() {
      return [
        { id: "single", name: this.$t("MESSAGES.ticketTypeSingle") },
        { id: "multiple", name: this.$t("MESSAGES.ticketTypeMultiple") },
      ];
    },
  },
  methods: {
    resetButton() {
      this.data.lat = null;
      this.data.lng = null;
    },
    async getFestivalsProviders() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "festival-providers?page=0&limit=0&is_active=1",
        });
        this.allMainProviders = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    setLocation(event, index) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();

      this.data.lat = lat;
      this.data.lng = lng;

      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          this.data.address = results[0].formatted_address;
        } else {
          this.data.address = "--";
        }
      });
    },
    setPlace(place) {
      this.currentPlace = place;
      this.addMarker();
    },
    addMarker() {
      if (this.currentPlace) {
        this.data.lat = this.currentPlace.geometry.location.lat();
        this.data.lng = this.currentPlace.geometry.location.lng();
        this.currentPlace = null;
      }
    },
    addRow() {
      this.phone_numbers.push({ phone: "" });
    },

    removeRow(index) {
      this.phone_numbers.splice(index, 1);
    },
    onFileSelect(files) {
      this.additionalImages = files;
    },
    onFileRemove(index) {
      this.$delete(this.data.imgUrls, index);
    },
    onFileSelectField(files) {
      this.data.additionalImages = files;
    },
    onFileRemoveField(index) {
      this.$delete(this.data.imgUrls, index);
    },
    selectImage(selectedImage) {
      this.data.media = selectedImage;
    },

    showFields(storeId) {
      if (storeId && storeId.fields) {
        this.data.section_id = storeId;
      }
    },
    validateFormInputs() {
      const prerequisiteError = validateFestivalSchedulePrerequisites(
        {
          type: this.data.type,
          startDate: this.data.start_date,
          endDate: this.data.end_date,
        },
        (key, params) => this.$t(key, params)
      );
      if (prerequisiteError) {
        this.$message.error(prerequisiteError.message);
        return;
      }

      if (!this.data.ticket_type?.id) {
        this.$message.error(this.$t("MESSAGES.ticketTypeRequired"));
        return;
      }

      if (this.data.children_pricing_enabled) {
        const minAge = Number(this.data.min_age);
        const maxAge = Number(this.data.max_age);
        const childPrice = Number(this.data.child_price);
        if (
          this.data.min_age === null ||
          this.data.min_age === "" ||
          Number.isNaN(minAge) ||
          minAge < 0 ||
          minAge > 100
        ) {
          this.$message.error(this.$t("MESSAGES.minAgeRequired"));
          return;
        }
        if (
          this.data.max_age === null ||
          this.data.max_age === "" ||
          Number.isNaN(maxAge) ||
          maxAge < 0 ||
          maxAge > 100
        ) {
          this.$message.error(this.$t("MESSAGES.maxAgeRequired"));
          return;
        }
        if (maxAge < minAge) {
          this.$message.error(this.$t("MESSAGES.maxAgeMustBeGteMinAge"));
          return;
        }
        if (
          this.data.child_price === null ||
          this.data.child_price === "" ||
          Number.isNaN(childPrice) ||
          childPrice < 0
        ) {
          this.$message.error(this.$t("MESSAGES.childPriceRequired"));
          return;
        }
      }

      this.$refs.dailySchedule?.showAllValidation();
      const scheduleError = validateSchedules(
        this.dailySchedules,
        (key, params) => this.$t(key, params)
      );
      if (scheduleError) {
        this.$message.error(scheduleError.message);
        this.$refs.dailySchedule?.focusScheduleError(scheduleError);
        return;
      }

      const usagePolicyError = validateUsagePolicyFields(
        this.data.usage_policy_ar,
        this.data.usage_policy_en,
        (key) => this.$t(key)
      );
      if (usagePolicyError) {
        this.$message.error(usagePolicyError);
        return;
      }

      this.isWaitingRequest = true;
      this.submitForm();
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();

      // Basic fields
      REQUEST_DATA.append("name[ar]", this.data.nameAr ?? "");
      REQUEST_DATA.append("name[en]", this.data.nameEn ?? "");
      REQUEST_DATA.append("description[ar]", this.data.descProd ?? "");
      REQUEST_DATA.append("description[en]", this.data.descProdEn ?? "");
      if (this.data.media.file)
        REQUEST_DATA.append("image", this.data.media.file);

      REQUEST_DATA.append(
        "festival_provider_id",
        this.data.festival_provider_id?.id ?? ""
      );
      REQUEST_DATA.append("price", this.data.price);
      REQUEST_DATA.append(
        "is_name_required",
        this.data.is_name_required ? 1 : 0
      );
      REQUEST_DATA.append(
        "children_pricing_enabled",
        this.data.children_pricing_enabled ? 1 : 0
      );
      if (this.data.children_pricing_enabled) {
        REQUEST_DATA.append("min_age", this.data.min_age);
        REQUEST_DATA.append("max_age", this.data.max_age);
        REQUEST_DATA.append("child_price", this.data.child_price);
      }
      if (this.data.lat) REQUEST_DATA.append("lat", this.data.lat);
      if (this.data.lng) REQUEST_DATA.append("lng", this.data.lng);
      if (this.data.address) REQUEST_DATA.append("address", this.data.address);
      REQUEST_DATA.append("type", this.data.type?.id ?? "");
      if (this.data.start_date)
        REQUEST_DATA.append(
          "festival_date",
          formatDateForApi(this.data.start_date)
        );
      if (this.data.end_date)
        REQUEST_DATA.append("end_date", formatDateForApi(this.data.end_date));
      REQUEST_DATA.append("usage_policy[ar]", this.data.usage_policy_ar);
      REQUEST_DATA.append("usage_policy[en]", this.data.usage_policy_en);
      appendScheduleToFormData(
        REQUEST_DATA,
        this.dailySchedules,
        this.data.ticket_type?.id
      );
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);

      // Send the request with the FormData
      try {
        await this.$axios({
          method: "POST",
          url: "festivals",
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/festivals/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(
          getFestivalApiErrorMessage(error) || this.$t("MESSAGES.errorOccurred")
        );
      }
    },
  },

  created() {
    this.getFestivalsProviders();
  },
};
</script>
<style>
.pac-target-input {
  width: 100% !important;
}
</style>
